import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=55f586e0&scoped=true"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=55f586e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f586e0",
  null
  
)

export default component.exports